module.exports = __webpack_public_path__ + "static/img/R508B.e00aa64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/UltralowTemperature/R508B.jpg
// module id = HHLx
// module chunks = 1